import React, { FunctionComponent } from 'react'
import { PurchaseOrderReceipt, ICompany } from '@getgreenline/homi-shared'
import { POImportProductsAdmin } from './ImportProducts/POImportProductsAdmin'
import { POCatalogueProducts } from './ImportProducts/POCatalogueProducts'
import { CurrentCompanyStore } from '../../../../../../stores/CurrentCompanyStore'
import { POCatalogueProductsAdmin } from './ImportProducts/POCatalogueProductsAdmin'
import { POImportProducts } from './ImportProducts/POImportProducts'

interface Props {
  receiptResponse: PurchaseOrderReceipt
  company: ICompany
  refreshReceiptProducts: () => void
  isRefreshing: boolean
  currentCompanyStore: CurrentCompanyStore
  categoryWarningCount: number
  canCreateProductsInPO: boolean
}

export const ReceiptProducts: FunctionComponent<Props> = (props: Props): JSX.Element => {
  const {
    company,
    receiptResponse,
    refreshReceiptProducts,
    isRefreshing,
    currentCompanyStore,
    categoryWarningCount,
    canCreateProductsInPO,
  } = props
  const { foundInCatalogue, notFound } = receiptResponse

  return (
    <>
      {canCreateProductsInPO ? (
        <POImportProductsAdmin
          companyId={company.id}
          receiptResponse={receiptResponse}
          currentCompanyStore={currentCompanyStore}
          categoryWarningCount={categoryWarningCount}
        />
      ) : (
        <POImportProducts companyId={company.id} receiptResponse={receiptResponse} />
      )}

      {(foundInCatalogue.length > 0 || notFound.length > 0) &&
        (canCreateProductsInPO ? (
          <POCatalogueProductsAdmin
            company={company}
            foundInCatalogue={foundInCatalogue}
            notFound={notFound}
            refreshReceiptProducts={refreshReceiptProducts}
            isRefreshing={isRefreshing}
            currentCompanyStore={currentCompanyStore}
          />
        ) : (
          <POCatalogueProducts
            company={company}
            foundInCatalogue={foundInCatalogue}
            notFound={notFound}
            refreshReceiptProducts={refreshReceiptProducts}
            isRefreshing={isRefreshing}
          />
        ))}
    </>
  )
}
